import api from '@utils/api'
import moment from 'moment'

export const handleSubmit = (formData, selectedRows, onFinish) => {
  if (!selectedRows) return
  const tankTransition = {}
  tankTransition.stores = []
  selectedRows.forEach((r) => {
    tankTransition.stores.push({ store_number: r.store_number, tank_id: r.tank_id })
  })

  tankTransition.dispatch_product = formData.updated_dispatch_product
  tankTransition.customer_product = formData.updated_customer_product
  tankTransition.dispatch_date = moment(formData.updated_dispatch_date).startOf('day').toISOString()
  tankTransition.customer_date = moment(formData.updated_customer_date).startOf('day').toISOString()
  api.createTankTransitions(tankTransition).then(() => {
    onFinish()
  })
}

export const handleRemove = (selectedRows, removeMutation, onFinish) => {
  if (!selectedRows) return
  const transitionIds = []
  selectedRows.forEach((r) => {
    if (r.has_transition) transitionIds.push(r.tank_transition.key)
  })

  removeMutation(transitionIds).then(() => onFinish && onFinish())
}
